import Icon from "@/icons";
import Tippy from "@tippyjs/react";
import { User } from "types";

export default function BotTag({ user, isTest }: { user?: User, isTest?: boolean }) {
    return (
        <>
            {user?.bot || isTest ? (
                <Tippy content="Bot" placement="top" arrow={true}>
                    <div className="flex items-center bg-brand-green px-2 scale-75 h-6 rounded-lg">
                        <p className="text-white font-semibold text-sm">BOT</p>
                    </div>
                </Tippy>
            ) : null}

            {user?.system ? (
                <Tippy content="System" placement="top" arrow={true}>
                    <div className="flex items-center bg-brand-green px-2 gap-2 scale-75 h-6 rounded-lg">
                        <Icon name="shield" size="16" />
                        <p className="text-white font-semibold text-sm">SYSTEM</p>
                    </div>
                </Tippy>
            ) : null}
        </>
    );
}